import {initializePaddle} from '@paddle/paddle-js';
import {apolloClient} from '@/plugins/apollo'
import gql from "graphql-tag"

let credentials;
let paddle;
export async function openCheckout(priceId, user_id, email) {
    await loadPaddle();
    paddle.Checkout.open({
        items: [{priceId: priceId}],
        customer: {email: email},
        customData: {user_id: user_id},
        pwCustomer: {email: email}
    })
}

export async function editTransactionCheckout(transactionId) {
    await loadPaddle();
    paddle.Checkout.open({
        transactionId: transactionId
    })
}

let registeredEvents = {};
export function registerEventCallback(name, callback) {
    registeredEvents[name] = callback;
}

export function updateCheckout(data) {
    paddle.Checkout.updateCheckout(data);
}

export function closeCheckout() {
    paddle.Checkout.close();
}

export async function loadPaddle() {
    if (paddle) {
        return paddle;
    }
    const credentials = await loadCredentials();
    if (credentials.environment && credentials.sellerId) {
        paddle = await initializePaddle({
            environment: credentials.environment,
            // seller: credentials.sellerId,
            token: credentials.token,
            pwAuth: credentials.retainToken,
            eventCallback: (event) => {
                if (event?.name && typeof registeredEvents[event?.name] === 'function') {
                    registeredEvents[event?.name](event.data);
                }
            }
        });
        return paddle;
    } else {
        return null;
    }
}

async function loadCredentials() {
    if (credentials) {
        return credentials;
    }
    let fetchRes = await apolloClient.query({
        query: gql(`query paddleCredentials { paddleCredentials { environment sellerId token retainToken }}`),
    });
    if (fetchRes.data && fetchRes.data.paddleCredentials) {
        credentials = fetchRes.data.paddleCredentials;
        return credentials;
    } else {
        console.error('No credentials in response', fetchRes);
        return {};
    }
}

export async function getProducts() {
    let fetchRes = await apolloClient.query({
        query: gql(`query paddleProducts { paddleProducts }`),
    });
    if (fetchRes.data && fetchRes.data.paddleProducts) {
        return JSON.parse(fetchRes.data.paddleProducts);
    } else {
        console.error('No products in response', fetchRes);
        return {};
    }
}

export async function cancelSubscription(subscriptionId) {
    const mutation = gql`
        mutation {
            cancelSubscription(subscriptionId: "${subscriptionId}") {
                success
                errors
            }
        }
    `
    let response = await apolloClient.mutate({mutation})
    return response.success;
}

export async function subscriptionScheduleReset(subscriptionId) {
    const mutation = gql`
        mutation {
            subscriptionResetSchedule(subscriptionId: "${subscriptionId}") {
                success
                errors
            }
        }
    `
    let response = await apolloClient.mutate({mutation})
    return response.success;
}

export async function updateSubscriptionPrice(priceId) {
    const mutation = gql`
        mutation {
            updateCurrentSubscriptionPrice(priceId: "${priceId}") {
                success
                errors
            }
        }
    `
    let response = await apolloClient.mutate({mutation})
    return response.success;
}